const getClicksPercentage = function (clicks, messages) {
  return !messages ? 0 : (clicks / messages) * 100
}

const Stats = {
  getClicksPercentage
}

export default Stats
